
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightAol as ObiLightAolElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-aol.js';
 
 
 

 
 export const ObiLightAol = createComponent({
   react: React,
   tagName: 'obi-light-aol',
   elementClass: ObiLightAolElement,
   events: {
     
   }
  });
 
 